export type Sun0 = 0 | 1 | 2 | 3 | 4 | 5 | 6; // Sun..Sat

const NAME_TO_SUN0: Record<string, Sun0> = {
  // Sunday
  sunday: 0,
  sun: 0,
  'sun.': 0,
  // Monday
  monday: 1,
  mon: 1,
  'mon.': 1,
  // Tuesday
  tuesday: 2,
  tue: 2,
  tues: 2,
  'tue.': 2,
  'tues.': 2,
  // Wednesday
  wednesday: 3,
  wed: 3,
  weds: 3,
  'wed.': 3,
  // Thursday
  thursday: 4,
  thu: 4,
  thur: 4,
  thurs: 4,
  'thu.': 4,
  'thur.': 4,
  'thurs.': 4,
  // Friday
  friday: 5,
  fri: 5,
  'fri.': 5,
  // Saturday
  saturday: 6,
  sat: 6,
  'sat.': 6,
};

/** Convert Monday-based index (Mon=0..Sun=6) to Sunday-based (Sun=0..Sat=6). */
export const mon0ToSun0 = (mon0: number): Sun0 => ((mon0 + 1) % 7) as Sun0;

/** Convert Monday-based index (Mon=1..Sun=7) to Sunday-based (Sun=0..Sat=6). */
export const mon1ToSun0 = (mon1: number): Sun0 => (mon1 === 7 ? 0 : (mon1 as Sun0));

/**
 * Best-effort normalization for coach inputs:
 * - strings like 'Monday', 'Thur', 'Weds'
 * - numbers Mon=0..Sun=6  (common in editors)
 * - numbers Mon=1..Sun=7  (some exports)
 * - already-Sun0 numbers (rare). If you KNOW it’s Sun0, pass { alreadySun0:true }.
 */
export function normalizeCoachDow(input: unknown, opts: { alreadySun0?: boolean } = {}): Sun0 | null {
  if (input == null) return null;

  if (typeof input === 'number' && Number.isInteger(input)) {
    const n = input as number;
    if (opts.alreadySun0) {
      if (n >= 0 && n <= 6) return n as Sun0;
      return null;
    }
    if (n >= 0 && n <= 6) return mon0ToSun0(n);
    if (n >= 1 && n <= 7) return mon1ToSun0(n);
    return null;
  }

  if (typeof input === 'string') {
    const key = input.trim().toLowerCase();
    if (key in NAME_TO_SUN0) return NAME_TO_SUN0[key];
    return null;
  }

  return null;
}

/** Local midnight (strip time) to be safe for DOW math. */
export function atLocalMidnight(d = new Date()): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
